module.exports = function isArray(x) {
  return Array.isArray ? Array.isArray(x) : x instanceof Array;
};


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/tcomb/lib/isArray.js
// module id = 34
// module chunks = 0